import API from '../../sunwiseAPI';
const ENTITY = 'accumulated-savings';

export const getData = (project_id, final_date) =>
    API.get(`/api/v1/${ENTITY}/sunpay/`, {
        params: { project_id, final_date },
    });
